import React, { FC } from 'react';
import { NewUnitSiteFormProps } from './NewUnitSiteFormProps';
import LocationInfoFields from '../LocationInfoFields';
import SiteInfoFields from '../SiteInfoFields';
import Divider from '../../Divider';
import SiteProgressInfoFields from '../SiteProgressInfoFields';

const NewUnitSiteForm: FC<NewUnitSiteFormProps> = ({
  countries,
  BuList,
  onCountryChange,
  onBUChange,
  transactionType,
  isLeasedFromAnotherIngkaCompany,
  currencyRate,
  currency,
  isEdit,
}) => {
  return (
    <>
      <LocationInfoFields
        countries={countries}
        locationName
        onCountryChange={onCountryChange}
        onBUChange={onBUChange}
        BUList={BuList}
        buCode
        isEdit={isEdit}
      />
      <SiteInfoFields
        lease
        land
        building
        unitType
        transactionType={transactionType}
        isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
        site
        currencyRate={currencyRate}
        currency={currency}
      />
      <Divider />
      <SiteProgressInfoFields />
    </>
  );
};

export default NewUnitSiteForm;
